var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnailHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0477 13.9192C11.0262 13.9192 11.0045 13.9173 10.9827 13.9133C10.7899 13.8775 10.6627 13.6924 10.6984 13.4998L11.554 8.88685C11.5897 8.69418 11.7742 8.56738 11.9676 8.60253C12.1604 8.63841 12.2876 8.82343 12.2519 9.0161L11.3963 13.629C11.3646 13.7999 11.2154 13.9192 11.0477 13.9192Z",
    fill: "#D2A582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92826 13.9194C9.76072 13.9194 9.61171 13.8003 9.57983 13.6298L8.7156 9.01698C8.67954 8.82431 8.80639 8.63894 8.99906 8.60289C9.19173 8.56649 9.37727 8.69385 9.41315 8.88635L10.2774 13.4993C10.3134 13.6919 10.1866 13.8773 9.99392 13.9134C9.97192 13.9175 9.94992 13.9194 9.92826 13.9194Z",
    fill: "#D2A582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9816 26.4874L27.1613 25.2739L13.2785 21.0596C12.6665 20.6856 12.2581 20.0113 12.2581 19.2416V14.6287C12.2581 13.6488 11.4638 12.8545 10.4839 12.8545H9.06451C8.47661 12.8545 8 13.3311 8 13.919V14.2738C8 15.2005 8.59297 15.9865 9.41934 16.2791V20.6609C9.41934 24.5804 12.5967 27.7577 16.5161 27.7577H28.5969C28.9799 27.7577 29.2903 27.4472 29.2903 27.0643C29.2903 26.8325 29.1744 26.616 28.9816 26.4874Z",
    fill: "#E0C7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9035 9.66153C12.2955 9.66153 12.6132 9.3438 12.6132 8.95186C12.6132 8.55992 12.2955 8.24219 11.9035 8.24219C11.5116 8.24219 11.1938 8.55992 11.1938 8.95186C11.1938 9.3438 11.5116 9.66153 11.9035 9.66153Z",
    fill: "#AF6853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0509 9.15152C12.2165 9.15152 12.3507 9.01726 12.3507 8.85164C12.3507 8.68602 12.2165 8.55176 12.0509 8.55176C11.8852 8.55176 11.751 8.68602 11.751 8.85164C11.751 9.01726 11.8852 9.15152 12.0509 9.15152Z",
    fill: "#D79885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06465 9.66153C9.45659 9.66153 9.77432 9.3438 9.77432 8.95186C9.77432 8.55992 9.45659 8.24219 9.06465 8.24219C8.67271 8.24219 8.35498 8.55992 8.35498 8.95186C8.35498 9.3438 8.67271 9.66153 9.06465 9.66153Z",
    fill: "#AF6853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16462 9.15152C9.33024 9.15152 9.4645 9.01726 9.4645 8.85164C9.4645 8.68602 9.33024 8.55176 9.16462 8.55176C8.99901 8.55176 8.86475 8.68602 8.86475 8.85164C8.86475 9.01726 8.99901 9.15152 9.16462 9.15152Z",
    fill: "#D79885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.871 27.0481H23.554H17.9355C14.0161 27.0481 10.8387 23.8707 10.8387 19.9513V16.4973C10.8387 16.2361 10.6896 16.0062 10.4649 15.8731C9.83932 15.5028 9.41934 14.8225 9.41934 14.0428V12.8545H9.06451C8.47661 12.8545 8 13.3311 8 13.919V14.2738C8 15.2005 8.59297 15.9865 9.41934 16.2791V20.6609C9.41934 24.5804 12.5967 27.7577 16.5161 27.7577H27.8709C28.0669 27.7577 28.2258 27.5988 28.2258 27.4029C28.2258 27.2069 28.067 27.0481 27.871 27.0481Z",
    fill: "#D5A871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9427 11.835C16.3801 11.835 12.9017 16.3496 13.3638 21.3974C13.4921 22.7987 15.3498 25.8155 19.0485 23.6841C19.9291 25.2661 21.615 26.3385 23.5542 26.3385C27.1142 26.3385 30.0002 23.4525 30.0002 19.8925C30.0002 15.4424 26.3927 11.835 21.9427 11.835Z",
    fill: "#D79885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4928 22.417C15.0307 17.3693 18.5092 12.8547 24.0717 12.8547C24.8989 12.8547 25.6968 12.9797 26.4479 13.2113C25.1619 12.3423 23.6115 11.835 21.9427 11.835C16.3801 11.835 12.9017 16.3496 13.3638 21.3974C13.4575 22.4216 14.4766 24.3068 16.4621 24.4159C15.8651 23.7751 15.5435 22.9704 15.4928 22.417Z",
    fill: "#AF6853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1041 20.3565C26.1041 18.3409 24.4644 16.7012 22.4488 16.7012C20.9135 16.7012 19.3774 17.6174 18.5352 19.0354C18.0229 19.8977 17.3825 21.6378 18.4162 24.0061C18.6206 23.9151 18.8308 23.8093 19.0478 23.6842C18.385 22.1316 18.4138 20.6296 19.1454 19.3978C19.8513 18.2094 21.1788 17.4108 22.4488 17.4108C24.0729 17.4108 25.3944 18.7323 25.3944 20.3564C25.3944 21.6166 24.3692 22.6417 23.1089 22.6417C22.1399 22.6417 21.3515 21.8534 21.3515 20.8843C21.3515 20.0454 21.9551 19.6196 22.516 19.5787C23.0051 19.544 23.5696 19.7921 23.6873 20.5978C23.7153 20.7917 23.8966 20.9258 24.0896 20.8975C24.2834 20.8693 24.4177 20.6891 24.3893 20.4952C24.2133 19.2895 23.2969 18.8111 22.4646 18.8709C21.5588 18.9367 20.6419 19.6496 20.6419 20.8844C20.6419 22.2447 21.7487 23.3514 23.1089 23.3514C24.7605 23.3514 26.1041 22.008 26.1041 20.3565Z",
    fill: "#AF6853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1291 16.4297C9.87654 16.4297 9.63716 16.3749 9.41943 16.2793V17.0348C9.6445 17.1021 9.88242 17.1394 10.1291 17.1394C10.325 17.1394 10.4839 16.9805 10.4839 16.7845C10.4839 16.5886 10.3251 16.4297 10.1291 16.4297Z",
    fill: "#D2A582"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: -1,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.84 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnailHighlight);
export default __webpack_public_path__ + "static/media/snail-highlight.bc5f037c10e28ec0f71c2e56de938f48.svg";
export { ForwardRef as ReactComponent };